import { ApiService } from "./ApiService.js";
import { ServiceConsts } from "./ServiceConsts.js";

export const TENANT_STORAGE_KEY = "activeTenant";

export class TenantService {
    static async getTenants() {
        let tenants = await ApiService.get(`${ServiceConsts.API_URL}/tenants`);

        // sort tenants by name
        tenants = tenants.sort((a, b) => {
            // personal tenant comes first, rest is sorted by name
            if (!a.personal && !b.personal) return 1;
            if (a.personal && !b.personal) return -1;
            return a.name.localeCompare(b.name);
        });

        return tenants;
    }

    static async getTenant(tenantId) {
        return ApiService.get(`${ServiceConsts.API_URL}/tenants/${tenantId}`);
    }

    static async createTenant(tenant) {
        return ApiService.post(`${ServiceConsts.API_URL}/tenants`, tenant);
    }

    static async updateTenant(tenant) {
        return ApiService.patch(
            `${ServiceConsts.API_URL}/tenants/${tenant.id}`,
            tenant,
        );
    }

    static async deleteTenant(tenantId) {
        return ApiService.delete(
            `${ServiceConsts.API_URL}/tenants/${tenantId}`,
        );
    }

    static async getTenantAuthorities(tenantId) {
        return ApiService.get(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/authorities`,
        );
    }

    static async createTenantAuthority(tenantId, authority) {
        return ApiService.post(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/authorities`,
            authority,
        );
    }

    static async deleteTenantAuthority(tenantId, authorityId) {
        return ApiService.delete(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/authorities/${authorityId}`,
        );
    }

    static async uploadTenantLogo(tenantId, file) {
        return ApiService.postFile(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/logo`,
            file,
        );
    }

    static async updateSubscription(tenantId, subscription) {
        return ApiService.patch(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/subscription`,
            subscription,
        );
    }

    static async getTenantCollaborators(tenantId) {
        return ApiService.get(
            `${ServiceConsts.API_URL}/tenants/${tenantId}/collaborators`,
        );
    }
}
